import { SVGProps, Ref, forwardRef } from 'react';

export const ClockRewindOutlinedSize12Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={12} height={12} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    d="M10.95 6c0 1.056-.265 2.057-.87 2.783-.593.71-1.567 1.23-3.142 1.23a5.3 5.3 0 0 1-1.6-.223l-.814.813c.668.296 1.47.46 2.414.46 1.827 0 3.122-.616 3.948-1.607C11.698 8.48 12 7.212 12 6s-.302-2.481-1.114-3.456C10.06 1.553 8.766.938 6.938.938s-3.122.615-3.949 1.606C2.177 3.52 1.875 4.788 1.875 6v1.733L.746 6.603l-.742.743L2.4 9.742l2.396-2.396-.743-.742-1.128 1.129V6c0-1.056.265-2.056.87-2.783.593-.71 1.567-1.23 3.143-1.23s2.55.52 3.141 1.23c.606.726.871 1.727.871 2.783"
                    fill="currentColor"
                />
                <path d="M6.413 3v3.293L9.1 7.947l.55-.894-2.187-1.346V3z" fill="currentColor" />
            </g>
        </g>
    </svg>
));
ClockRewindOutlinedSize12Glyph.displayName = 'ClockRewindOutlinedSize12Glyph';
